<template>
    <div>
        <div v-if="!!notts"> 
            <v-badge color="primary" overlap bordered offset-y="9" offset-x="9">
                <template v-slot:badge>
                    <span>{{ notts }}</span> 
                </template>      
                <v-btn color="primary" small block v-on:click="showDialog(encrid)">  
                    <v-icon small>mdi-briefcase-outline</v-icon><span>&nbsp;notes</span>
                </v-btn>
            </v-badge>   
        </div>   
        <div v-else>
            <v-btn small block :disabled="!!notts" elevation="0" v-on:click="showDialog(encrid)">  
                <v-icon small>mdi-briefcase-outline</v-icon><span>&nbsp;notes</span>
            </v-btn>
        </div>    
    </div>
</template>

<script>
    export default {    
        props: {
            notts: {
                type: Number,
                default: 0
            },
            encrid: {
                type: String,
                default: ''
            },  
            noto_oms: {
                type: String,
                default: ''
            },  
        },
        methods: {
            showDialog(encrid){
                this.$emit('showDialog', encrid, this.noto_oms);
            },
        }
    }
</script>

<style scoped>

</style>